export default __webpack_public_path__ + "static/NotoSans-BoldItalic-406a212cc6ccd7d97e59e52c3c2a0c79.ttf";